import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Mail, ShieldCheck, Video } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from '../components/modals/LoginModal';
import RegisterModal from '../components/modals/RegisterModal';
import ForgotPasswordModal from '../components/modals/ForgotPasswordModal';
import {
  trackFirstPartyEventOnce,
} from '../lib/firstPartyAnalytics';

const VkLanding = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    trackFirstPartyEventOnce('landing_view', `vk:${window.location.pathname}`);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    navigate(userData?.email?.includes('admin') ? '/admin' : '/videochat');
  }, [isAuthenticated, navigate]);

  const openRegistration = () => {
    trackFirstPartyEventOnce('registration_cta_click', `vk:${window.location.pathname}`);
    setShowRegister(true);
  };

  return (
    <div className="relative min-h-[100dvh] overflow-hidden bg-gradient-to-b from-[#F4F7FF] via-white to-[#FFF4F6] px-4">
      <div className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full bg-[#7B61FF]/10 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#FF5757]/10 blur-2xl" />

      <main className="relative z-10 mx-auto flex min-h-[100dvh] w-full max-w-md flex-col justify-center py-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))]">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1A73E8] to-[#7B61FF] shadow-lg">
            <Heart className="h-6 w-6 fill-white text-white" aria-hidden="true" />
          </div>
          <span className="text-2xl font-extrabold tracking-tight text-[#1F1F1F]">Speed-Date</span>
        </div>

        <section className="rounded-[2rem] border border-white/80 bg-white/90 p-6 shadow-2xl shadow-[#6A9EFF]/15 backdrop-blur sm:p-8">
          <p className="mb-3 inline-flex rounded-full bg-[#EAF2FF] px-3 py-1 text-sm font-semibold text-[#1A73E8]">
            Знакомства в живом формате
          </p>
          <h1 className="text-4xl font-extrabold leading-[1.08] tracking-tight text-[#1F1F1F]">
            Видеознакомства до 10 минут
          </h1>
          <p className="mt-4 text-lg leading-7 text-[#5F6368]">
            Если интерес взаимный — откроется личный чат
          </p>

          <ul className="mt-6 space-y-3 text-[15px] font-medium text-[#36383B]" aria-label="Преимущества регистрации">
            <li className="flex items-center gap-3">
              <ShieldCheck className="h-5 w-5 flex-none text-[#34A853]" aria-hidden="true" />
              Только 18+
            </li>
            <li className="flex items-center gap-3">
              <Video className="h-5 w-5 flex-none text-[#1A73E8]" aria-hidden="true" />
              Телефон не нужен
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-5 w-5 flex-none text-[#7B61FF]" aria-hidden="true" />
              Email нужен для защиты аккаунта
            </li>
          </ul>

          <button
            type="button"
            onClick={openRegistration}
            className="mt-7 min-h-14 w-full rounded-full bg-gradient-to-r from-[#FF5757] to-[#FF7B7B] px-6 py-4 text-lg font-bold text-white shadow-lg shadow-[#FF5757]/20 transition-transform active:scale-[0.99]"
            data-testid="vk-register-button"
          >
            Зарегистрироваться бесплатно
          </button>

          <button
            type="button"
            onClick={() => setShowLogin(true)}
            className="mt-4 w-full py-2 text-sm font-medium text-[#5F6368] underline-offset-4 hover:text-[#1A73E8] hover:underline"
            data-testid="vk-login-link"
          >
            Уже есть аккаунт? Войти
          </button>
        </section>

        <p className="mt-5 text-center text-xs leading-5 text-[#7A7A7A]">
          После подтверждения email вы заполните профиль и сможете выбрать, с кем знакомиться.
        </p>
      </main>

      <LoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToRegister={() => {
          setShowLogin(false);
          openRegistration();
        }}
        onForgotPassword={() => {
          setShowLogin(false);
          setShowForgotPassword(true);
        }}
      />

      <RegisterModal
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        onSwitchToLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />

      <ForgotPasswordModal
        isOpen={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
        onBackToLogin={() => {
          setShowForgotPassword(false);
          setShowLogin(true);
        }}
      />
    </div>
  );
};

export default VkLanding;

